import { agencyStrings } from '@data/agency';
import { requiredStringField, stringField } from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const agencyBase = t.type({
  fcp_no: t.string,
  name: t.string,
  name_short: t.string,
  name_en: t.string,
  name_en_short: t.string,
  address1: t.string,
  address2: t.string,
  phone: t.string,
  fax: t.string,
});

export type AgencyBase = t.TypeOf<typeof agencyBase>;

export const agency = t.type({
  ...agencyBase.props,
  id: t.number,
  created_at: t.string,
  updated_at: t.string,
});

export type Agency = t.TypeOf<typeof agency>;

export const agencyFc = t.type({
  fcp_no: t.string,
  name: t.string,
  name_short: t.string,
  name_en: t.string,
  address1: t.string,
  address2: t.string,
  phone: t.string,
  fax: t.string,
});

export const agencyListData = t.type({
  ...agency.props,
  service_info: t.array(
    t.type({
      service_name: t.string,
      cities: t.array(t.string),
      route_number: t.number,
    }),
  ),
  staff_number: h.omittable(t.number),
});

export type AgencyListData = t.TypeOf<typeof agencyListData>;

export const agencyForm = t.type({
  fcp_no: requiredStringField(agencyStrings.fcpNo),
  name_en: requiredStringField(agencyStrings.englishName),
  name_en_short: requiredStringField(agencyStrings.englishName),
  name: stringField(agencyStrings.japaneseName),
  name_short: stringField(agencyStrings.japaneseNameShort),
  address1: stringField(agencyStrings.address1),
  address2: stringField(agencyStrings.address2),
  phone: stringField(agencyStrings.phone),
  fax: stringField(agencyStrings.fax),
});

export type AgencyForm = t.TypeOf<typeof agencyForm>;

export const fcAgencyGetQuery = t.type({
  agent_code: t.string,
  agent_english: t.string,
});

export type FcAgencyGetQuery = t.TypeOf<typeof fcAgencyGetQuery>;

export const agencyInitialValues: AgencyForm = {
  fcp_no: '',
  name_en: '',
  name_en_short: '',
  name: '',
  name_short: '',
  address1: '',
  address2: '',
  phone: '',
  fax: '',
};
